import React from "react";
import styles from './Ingredient.module.scss';
import PropTypes from 'prop-types';

const Ingredient = (props) => {
  const {Bacon, BreadBottom, BreadTop, Cheese, Meat, Salad, Seeds1, Seeds2} = styles;
  let ingredient = null;
  switch (props.type) {
    case ('bread-bottom'):
      ingredient = <div className={BreadBottom}></div>;
      break;
    case ('bread-top'):
      ingredient = (
        <div className={BreadTop}>
          <div className={Seeds1}></div>
          <div className={Seeds2}></div>
        </div>
      );
      break;
    case ('bacon'):
      ingredient = <div className={Bacon}></div>;
      break;
    case ('cheese'):
      ingredient = <div className={Cheese}></div>;
      break;
    case ('meat'):
      ingredient = <div className={Meat}></div>;
      break;
    case ('salad'):
      ingredient = <div className={Salad}></div>;
      break;
    default:
      ingredient = null;
  }
  return ingredient;
};

Ingredient.propTypes = {
  type: PropTypes.string.isRequired
};

export default Ingredient;
